import { camelToSentenceCase } from 'ns_libs/formatter';
import React from 'react';
import { BOECalculator } from 'views/DealDashboard/BOE/components/SlideoutForm/BOECalculator/BOECalculator';
import { BOESlideoutFormValues } from 'views/DealDashboard/BOE/components/SlideoutForm/types';

export interface BOEEstimatesProps {
  selectedAsset: string;
  boeValues: BOESlideoutFormValues;
  setBoeValues: React.Dispatch<React.SetStateAction<BOESlideoutFormValues>>
}

export const BOEEstimator: React.FC<BOEEstimatesProps> = ({ selectedAsset, boeValues, setBoeValues }) => (
    <div className="BOEEstimates">
        <h2 className="font-weight-bold">{`Back-of-envelope estimates: ${camelToSentenceCase(selectedAsset)}`}</h2>
        <h4 className="mb-3">Use our preset values or modify them as you see fit.</h4>
        <BOECalculator
            selectedAssetType={selectedAsset}
            boeValues={boeValues}
            setBoeValues={setBoeValues}
        />
    </div>
);

export default BOEEstimator;
